import React from 'react';
import { Modal } from '../Modal';
import {
  PopupContent,
  PopupMessage,
  modalStyles,
  PopupTitle,
  ButtonsContainer,
  buttonStyles,
  IconContainer,
  PopupFooterMessage
} from './styled';
import useScreenSize from '../../../hooks/useScreenSize';
import { Button } from '../Button';
import { ButtonType } from '../../../styled/theme/types';
import { Icon } from '../../Icon';
import { SVGComponent } from '../../Icon/types';

interface InformationPopupProps {
  isOpen: boolean;
  title: string;
  message?: string;
  modalId: string;
  acceptButtonText?: string;
  declineButtonText: string;
  titleTag?: string;
  declineButtonState?: ButtonType;
  acceptButtonState?: ButtonType;
  reverseButton?: boolean;
  icon?: SVGComponent;
  iconWidth?: number;
  iconHeight?: number;
  onAcceptHandlerClick?: () => void;
  onDeclineHandlerClick: () => void;
  acceptButtonDisabled?: boolean;
  acceptButtonStat?: string;
  loading?: boolean;
  footerMessage?: string;
}

export const InformationPopup: React.FC<InformationPopupProps> = ({
  isOpen,
  title,
  message,
  modalId,
  titleTag,
  declineButtonText,
  acceptButtonText,
  declineButtonState = ButtonType.default,
  acceptButtonState = ButtonType.delete,
  reverseButton = true,
  icon,
  iconWidth = 18,
  iconHeight = 16,
  onAcceptHandlerClick,
  onDeclineHandlerClick,
  acceptButtonDisabled = false,
  acceptButtonStat = '',
  loading,
  footerMessage
}) => {
  const { isSmall } = useScreenSize();

  return (
    <Modal
      modalId={modalId}
      isOpen={isOpen}
      modalStyles={modalStyles}
      onClose={onDeclineHandlerClick}
      lockScroll={isSmall}
      withAnimation={false}
    >
      <PopupContent data-cy={modalId}>
        {icon && (
          <IconContainer>
            <Icon
              width={iconWidth}
              height={iconHeight}
              indent={false}
              IconComponent={icon}
            />
          </IconContainer>
        )}

        <PopupTitle
          tag={titleTag || (isSmall ? 'title_3_desc' : 'title_3_new')}
          data-cy="information-popup-title"
        >
          {title}
        </PopupTitle>

        <PopupMessage tag="body_1" data-cy="information-popup-message">
          {message}
        </PopupMessage>

        <ButtonsContainer $withReverse={reverseButton}>
          {acceptButtonText && onAcceptHandlerClick && (
            <Button
              text={acceptButtonText}
              onClick={onAcceptHandlerClick}
              state={acceptButtonState}
              styles={buttonStyles}
              cypress="information-popup-accept-button"
              disabled={acceptButtonDisabled}
              stat={acceptButtonStat}
              loading={loading}
            />
          )}
          <Button
            text={declineButtonText}
            onClick={onDeclineHandlerClick}
            state={declineButtonState}
            styles={buttonStyles}
            cypress="information-popup-decline-button"
          />
        </ButtonsContainer>

        {footerMessage && (
          <PopupFooterMessage
            tag="body_2"
            data-cy="information-popup-footer-message"
          >
            {footerMessage}
          </PopupFooterMessage>
        )}
      </PopupContent>
    </Modal>
  );
};
